module.exports = __webpack_public_path__ + "img/avatar.bbd42cf9.png";